/* BYON ronda 10 + R1 · Ficha de producto (lo carga sections/byon-pdp-assets.liquid, defer).
   1. Bloques propios sincronizados con la variante: reemplaza [data-byon-swap] con el HTML que Dawn ya pidió al
      servidor (variantChange de pubsub.js). Precio, stock, pack y despacho salen siempre del servidor.
   2. Agotado: "Avísame cuando llegue" (Klaviyo) en el lugar del botón. Evento bis_open (K1).
   3. "Complétalo con": "+ Agregar" de un toque (POST /cart/add con sections) y abre el carro lateral.
   4. Barra fija (mobile): visible siempre que el botón principal no esté entero en pantalla (R1, UX-03);
      muestra el sabor elegido y "Agregar" usa el mismo botón principal (UX-02). body.byon-sticky-atc-visible.
   5. Contrato K3: body.byon-has-complements y el widget FBT se ubica en .byon-fbt-slot (fichas sin complementos).
   6. Medición K1: add_to_cart (pdp_main / pdp_sticky / pdp_complement) con la respuesta OK.
   El despacho según comuna está en assets/byon-product-delivery.js (window.byonPdpDelivery).
   R2 6(b): guard para el HierarchyRequestError del script de Lab51 (main-product.liquid) al cruzar 750 px. */
(function () {
  'use strict';
  if (window.byonPdp) return;

  /* R2 6(b). Lab51 mueve .container-fbt dentro de .container-fbt-mobile (< 750 px) y al revés (>= 750 px) en cada
     resize; si uno ya contiene al otro, appendChild lanza HierarchyRequestError. Este listener se registra antes que
     el de Lab51 (este archivo es defer; Lab51 se registra en DOMContentLoaded) y, solo al cruzar 750 px, saca al
     contenido para que Lab51 lo pueda mover sin error. El widget sigue en .byon-fbt-slot. */
  var fbtWide = window.innerWidth >= 750;
  window.addEventListener('resize', function () {
    var now = window.innerWidth >= 750;
    if (now === fbtWide) return;
    fbtWide = now;
    var F = document.querySelector('.container-fbt'), M = document.querySelector('.container-fbt-mobile');
    if (!F || !M) return;
    if (F.contains(M)) F.parentNode.insertBefore(M, F.nextSibling);
    else if (M.contains(F)) M.parentNode.insertBefore(F, M.nextSibling);
  });

  var d = document;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function closest(el, s) { return el && el.closest ? el.closest(s) : null; }
  function track(ev, p) { (window.byonTrack || function () {})(ev, p); }

  function findInfo() {
    var list = qsa('product-info[id^="ProductInfo-"]');
    for (var i = 0; i < list.length; i++) { if (!closest(list[i], 'quick-add-modal')) return list[i]; }
    return null;
  }

  var info = findInfo();
  if (!info) return;
  var sectionId = info.getAttribute('data-section') || '';
  var picker = qs('variant-radios, variant-selects', info);
  var sticky = qs('[data-byon-sticky]');
  var variants = [];
  if (picker) {
    try { variants = JSON.parse(qs('script[type="application/json"]', picker).textContent) || []; } catch (e) { variants = []; }
  }
  var pdata = {};
  try { pdata = JSON.parse(d.getElementById('ByonPdpData').textContent) || {}; } catch (e) { pdata = {}; }
  var state = { variant: null };

  function productForm() { return d.getElementById('product-form-' + sectionId); }
  function submitBtn() { return d.getElementById('ProductSubmitButton-' + sectionId) || qs('button[name="add"]', info); }
  function variantById(id) {
    id = Number(id);
    for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) return variants[i]; }
    return null;
  }
  function selectedVariant() {
    var f = productForm();
    var inp = f ? f.querySelector('[name="id"]') : null;
    return (inp && variantById(inp.value)) || null;
  }
  function money(cents) {
    var n = Math.round(Number(cents || 0) / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function renderDelivery() { if (window.byonPdpDelivery) window.byonPdpDelivery.render(); }

  /* ---------- K3: FBT solo donde no hay "Complétalo con" ---------- */
  if (d.getElementById('byon-has-complements')) d.body.classList.add('byon-has-complements');
  function placeFbt() {
    var slot = qs('[data-byon-fbt-slot]', info);
    if (!slot || d.body.classList.contains('byon-has-complements')) return;
    var w = qs('.cbb-frequently-bought-container');
    if (!w) { slot.classList.remove('has-fbt'); return; }
    var box = closest(w, '.container-fbt');
    if (!box || box.contains(slot)) box = w;
    if (!slot.contains(box)) slot.appendChild(box);
    slot.classList.toggle('has-fbt', w.offsetHeight > 20);
  }
  if (qs('[data-byon-fbt-slot]', info) && 'MutationObserver' in window) {
    var fbtQueued = false;
    var fbtObs = new MutationObserver(function () {
      if (fbtQueued) return;
      fbtQueued = true;
      window.requestAnimationFrame(function () { fbtQueued = false; placeFbt(); });
    });
    fbtObs.observe(d.body, { childList: true, subtree: true });
    setTimeout(function () { fbtObs.disconnect(); placeFbt(); }, 20000);
  }

  /* ---------- 1. Bloques que dependen de la variante ---------- */
  function swapFrom(html) {
    if (!html || !html.querySelector) return;
    qsa('[data-byon-swap]', info).forEach(function (el) {
      var key = el.getAttribute('data-byon-swap');
      var src = html.querySelector('[data-byon-swap="' + key + '"]');
      if (!src) return;
      Array.prototype.forEach.call(src.attributes, function (a) {
        if (a.name === 'class' || a.name.indexOf('data-') === 0) el.setAttribute(a.name, a.value);
      });
      if (src.hasAttribute('hidden')) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
      if (el.innerHTML !== src.innerHTML) el.innerHTML = src.innerHTML;
    });
    renderDelivery();
  }
  /* "Cambiar a pack": la variante del pack con la misma opción 1 (mapa de byon-pdp-pack.liquid, con los mismos
     sinónimos de sabor). Si el sabor no está en el mapa, se deja el enlace que pintó el servidor. */
  function flavorKey(s) {
    return String(s || '').toLowerCase().trim().replace(/vainilla ice cream/g, 'vainilla').replace(/strawberry/g, 'frutilla')
      .replace(/cookies and cream/g, 'cookies').replace(/cookies & cream/g, 'cookies');
  }
  function syncPack(v) {
    var a = qs('[data-byon-pack-link]', info);
    if (!a || !v) return;
    var map = {};
    try { map = JSON.parse(a.getAttribute('data-byon-pack-map') || '{}'); } catch (e) { map = {}; }
    var id = map[flavorKey(v.option1)];
    if (!id) return;
    var url = a.getAttribute('data-byon-pack-base') + '?variant=' + id;
    qsa('a', closest(a, '[data-byon-swap]') || a.parentNode).forEach(function (x) { x.setAttribute('href', url); });
  }

  /* ---------- 2. Agotado / "Avísame cuando llegue" ---------- */
  function trigger() { return qs('.byon-bis', info); }
  function setSoldState(available) {
    var soldout = !available;
    info.classList.toggle('byon-is-soldout', soldout);
    var cbq = qs('.container-buy-and-quantity', info);
    if (cbq) {
      cbq.classList.toggle('klaviyo-container', soldout);
      cbq.classList.toggle('byon-is-soldout', soldout);
    }
    var t = trigger();
    if (t) {
      t.classList.toggle('byon-bis--off', !soldout);
      t.style.display = soldout ? '' : 'none';
      var f = productForm();
      if (f && t.parentNode !== f) f.appendChild(t);
    }
    qsa('.klaviyo-bis-trigger:not(.byon-bis)', info).forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    applySticky();
  }
  var bisSticky = false;
  d.addEventListener('click', function (e) {
    var t = closest(e.target, '.byon-bis');
    if (!t) return;
    e.preventDefault();
    if (!info.contains(t)) return;
    var v = state.variant || selectedVariant();
    track('bis_open', { item_id: String(pdata.id || ''), variant_id: String(v ? v.id : (pdata.variant || '')), bis_source: bisSticky ? 'pdp_sticky' : 'pdp' });
  });

  function onVariant(v) {
    if (!v) return;
    state.variant = v;
    setSoldState(!!v.available);
    syncPack(v);
    updateSticky();
  }

  /* ---------- 6. Medición del botón principal y de la barra fija (K1) ---------- */
  var pending = null;
  var stickySrc = false;
  d.addEventListener('submit', function (e) {
    var f = e.target;
    /* getAttribute: en un <form> con <input name="id">, f.id devuelve ese input y no el atributo id. */
    if (!f || !f.getAttribute || f.getAttribute('id') !== 'product-form-' + sectionId) return;
    var fd;
    try { fd = new FormData(f); } catch (err) { return; }
    pending = {
      id: String(fd.get('id') || ''),
      qty: parseInt(fd.get('quantity'), 10) || 1,
      src: stickySrc ? 'pdp_sticky' : 'pdp_main',
      t: Date.now()
    };
  }, true);
  function onCartUpdate(ev) {
    stickyLoading(false);
    if (!pending || !ev || ev.source !== 'product-form' || String(ev.productVariantId) !== pending.id) return;
    var p = pending;
    pending = null;
    if (Date.now() - p.t > 30000) return;
    var v = variantById(p.id);
    var pr = (pdata.prices || {})[p.id];
    track('add_to_cart', {
      atc_source: p.src,
      item_id: String(pdata.id || ''),
      variant_id: p.id,
      item_name: pdata.title || (v && v.name) || '',
      price: pr != null ? Number(pr) : (v ? Math.round(v.price / 100) : 0),
      quantity: p.qty,
      currency: 'CLP'
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant || !variantById(data.variant.id)) return;
      if (data.sectionId && data.sectionId !== sectionId) return;
      swapFrom(data.html);
      onVariant(data.variant);
      placeFbt();
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, function () { pending = null; stickyLoading(false); });
  }

  if (picker) {
    picker.addEventListener('change', function () {
      hideHint();
      var v = picker.currentVariant || selectedVariant();
      if (v && variantById(v.id)) onVariant(v);
      else { state.variant = null; updateSticky(); }
    });
  }

  /* "¿Lo quieres ya? <sabor> está disponible": elige ese sabor sin recargar */
  d.addEventListener('click', function (e) {
    var a = closest(e.target, '[data-byon-pick]');
    if (!a || !picker || !info.contains(a)) return;
    var v = variantById(a.getAttribute('data-byon-pick'));
    if (!v || !v.options) return;
    e.preventDefault();
    var fieldsets = qsa('fieldset', picker);
    var last = null;
    v.options.forEach(function (val, i) {
      var fs = fieldsets[i];
      if (!fs) return;
      var inp = qsa('input[type="radio"]', fs).filter(function (x) { return x.value === val; })[0];
      if (inp && !inp.checked) { inp.checked = true; last = inp; }
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- 3. "Complétalo con": agregar de un toque y abrir el carro lateral ---------- */
  d.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-byon-add]');
    if (!btn || !info.contains(btn)) return;
    e.preventDefault();
    addOne(btn);
  });
  function addOne(btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var id = btn.getAttribute('data-byon-add');
    var row = closest(btn, '.byon-mini');
    var pickSel = row ? qs('[data-byon-variant]', row) : null;
    if (pickSel && pickSel.value) id = pickSel.value;
    var label = qs('[data-byon-add-label]', btn);
    var box = closest(btn, '[data-byon-swap]');
    var msg = box ? qs('[data-byon-add-msg]', box) : null;
    var cart = d.querySelector('cart-drawer') || d.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    var cfg = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete cfg.headers['Content-Type'];
    cfg.body = fd;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || '');
        track('add_to_cart', {
          atc_source: 'pdp_complement',
          item_id: String(res.product_id || ''),
          variant_id: String(res.variant_id || res.id || id),
          item_name: res.product_title || res.title || '',
          price: Math.round(Number(res.price || 0) / 100),
          quantity: 1, /* se agrega 1; res.quantity es el total de la línea en el carro */
          currency: 'CLP'
        });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'byon-complement', productVariantId: id, cartData: res });
        }
        btn.classList.add('is-added');
        if (label) label.textContent = 'Agregado';
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(res);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        if (msg) {
          msg.textContent = err && err.message ? err.message : 'No pudimos agregarlo. Intenta de nuevo.';
          msg.hidden = false;
        }
      })
      .then(function () {
        btn.classList.remove('is-loading');
        setTimeout(function () {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-added');
          if (label) label.textContent = 'Agregar';
        }, 2500);
      });
  }

  /* ---------- 4. Barra fija de compra (mobile) ---------- */
  var mq = window.matchMedia('(max-width: 749px)');
  var shown = false;
  function hasChoices() {
    if (!picker) return false;
    return qsa('fieldset', picker).some(function (fs) { return qsa('input[type="radio"]', fs).length > 1; }) ||
      qsa('select', picker).some(function (s) { return s.options.length > 1; });
  }
  /* "Elige tu sabor" solo si no hay ninguna variante elegida (p. ej., una combinación que no existe). */
  function needsChoice() { return hasChoices() && !state.variant; }
  function stickyLoading(on) {
    var b = sticky ? qs('[data-byon-sticky-add]', sticky) : null;
    if (b) b.classList.toggle('is-loading', !!on);
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function isAvailable() {
    var v = state.variant;
    if (v) return !!v.available;
    var t = trigger();
    return !(t && !t.classList.contains('byon-bis--off'));
  }
  function updateSticky() {
    if (!sticky) return;
    var v = state.variant;
    var name = qs('[data-byon-sticky-variant]', sticky);
    var price = qs('[data-byon-sticky-price]', sticky);
    var btn = qs('[data-byon-sticky-add]', sticky);
    var label = qs('[data-byon-sticky-label]', sticky);
    if (name) {
      if (needsChoice()) {
        name.textContent = 'Elige tu ' + (sticky.getAttribute('data-option') || 'opción');
        name.classList.add('is-missing');
      } else {
        if (v && hasChoices()) name.textContent = v.title;
        name.classList.remove('is-missing');
      }
    }
    if (v) {
      if (price) price.textContent = money(v.price);
      var src = v.featured_image && v.featured_image.src;
      var holder = qs('[data-byon-sticky-img]', sticky);
      if (src && holder) {
        var im = holder.querySelector('img');
        if (!im) { im = d.createElement('img'); im.alt = ''; im.width = 44; im.height = 44; holder.appendChild(im); }
        im.removeAttribute('srcset');
        im.src = sized(src, 120);
      }
    }
    var available = isAvailable();
    if (btn) btn.classList.toggle('is-soldout', !available);
    if (label) label.textContent = available ? 'Agregar' : 'Avísame';
    if (btn) btn.setAttribute('aria-label', (available ? 'Agregar al carro' : 'Avísame cuando llegue') + (name ? ': ' + name.textContent : ''));
  }
  /* El CTA que se ve: "Avísame" si la variante está agotada; si no, "Agregar al carro". */
  function cta() {
    var t = trigger();
    if (t && !t.classList.contains('byon-bis--off')) return t;
    return submitBtn();
  }
  function ctaOut() {
    var el = cta();
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.height) return false;
    return r.top < 0 || r.bottom > (window.innerHeight || d.documentElement.clientHeight);
  }
  function applySticky() {
    if (!sticky) return;
    var b = d.body.classList;
    var show = mq.matches && ctaOut() && !b.contains('byon-overlay-open') && !b.contains('overflow-hidden');
    if (show === shown) return;
    shown = show;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    if ('inert' in sticky) sticky.inert = !show;
    b.toggle('byon-sticky-atc-visible', show);
  }
  var hintEl = null;
  function showHint() {
    if (!picker) return;
    if (!hintEl) {
      hintEl = d.createElement('p');
      hintEl.className = 'byon-pick-hint';
      hintEl.setAttribute('role', 'status');
      picker.appendChild(hintEl);
    }
    hintEl.textContent = 'Elige tu ' + ((sticky && sticky.getAttribute('data-option')) || 'opción') + ' para agregarlo al carro.';
    hintEl.hidden = false;
  }
  function hideHint() { if (hintEl) hintEl.hidden = true; }
  function goToPicker() {
    var target = picker ? (qs('fieldset', picker) || picker) : info;
    /* Primero se abren los pills y el aviso (cambian la altura) y después se calcula el destino del scroll. */
    var more = picker ? qs('[data-byon-pills-more]:not([hidden])', picker) : null;
    if (more) more.click();
    if (needsChoice()) showHint();
    target.classList.remove('byon-pulse');
    void target.offsetWidth;
    target.classList.add('byon-pulse');
    var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }
  if (sticky) {
    sticky.addEventListener('click', function (e) {
      var btn = closest(e.target, '[data-byon-sticky-add]');
      if (!btn) return;
      e.preventDefault();
      if (needsChoice()) { goToPicker(); return; }
      if (!isAvailable()) {
        var t = trigger();
        if (t) { bisSticky = true; t.click(); bisSticky = false; } else goToPicker();
        return;
      }
      var sb = submitBtn();
      if (!sb || sb.disabled) { goToPicker(); return; }
      stickyLoading(true);
      stickySrc = true;
      sb.click();
      stickySrc = false;
      setTimeout(function () { stickyLoading(false); }, 4000);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(applySticky, { threshold: [0, 1] });
      [submitBtn(), trigger()].forEach(function (el) { if (el) io.observe(el); });
    } else {
      window.addEventListener('scroll', applySticky, { passive: true });
    }
    window.addEventListener('resize', applySticky);
    if (mq.addEventListener) mq.addEventListener('change', applySticky);
    else if (mq.addListener) mq.addListener(applySticky);
    new MutationObserver(applySticky).observe(d.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- 7. Reseñas: "Ver todas" ---------- */
  function initReviews() {
    var box = qs('[data-byon-reviews]');
    if (!box) return;
    var total = parseInt(box.getAttribute('data-total'), 10) || 0;
    var widget = qs('#looxReviews', box) || qs('.loox-widget', box);
    var more = qs('[data-byon-reviews-more]', box);
    var btn = more ? qs('[data-byon-reviews-all]', more) : null;
    if (!widget || !more || !btn) return;
    var limit = parseInt(widget.getAttribute('data-limit'), 10) || 0;
    if (!limit || total <= limit) return;
    more.hidden = false;
    btn.addEventListener('click', function () {
      var frame = qs('iframe', widget);
      widget.setAttribute('data-limit', String(total));
      if (frame && frame.src) {
        frame.src = frame.src.replace(/([?&]limit=)\d+/, '$1' + total);
      }
      more.hidden = true;
    });
  }

  /* ---------- Inicio ---------- */
  state.variant = selectedVariant();
  setSoldState(isAvailable());
  updateSticky();
  renderDelivery();
  placeFbt();
  [500, 1500, 3000, 6000].forEach(function (ms) { setTimeout(placeFbt, ms); });
  initReviews();
  window.byonPdp = { updateSticky: updateSticky, applySticky: applySticky, placeFbt: placeFbt, state: state };
})();
